
import { createApi } from "@reduxjs/toolkit/query/react";
import { templateApi } from "../Constant";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const TemplateApi = createApi({
    reducerPath: "TemplateApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    endpoints: (builder) => ({

        getTemplateList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getTemplateList"],
        }),

        createTemplate: builder.mutation({
            query: ({ data }) => ({
                url: `${templateApi.endPoint}/add`,
                method: "POST",
                body: data,

            }),
            invalidatesTags: [],
        }),
        updateTemplate: builder.mutation({
            query: ({ data, id }) => ({
                url: `${templateApi.endPoint}/update/${id}`,
                method: "PATCH",
                body: data,

            }),
            invalidatesTags: [],
        }),
    }),
});

export const {
    useCreateTemplateMutation,
    useGetTemplateListQuery,
    useUpdateTemplateMutation,
    

} = TemplateApi;